import { Controller } from "stimulus";
import { S as e, A as s, N as t, P as r } from "./vendor.js";
import Swiper from "swiper/swiper-bundle";
export default class extends Controller {
  connect() {
    // const swiper = new Swiper(".swiper", {
    //   effect: "coverflow",
    //   grabCursor: true,
    //   centeredSlides: true,
    //   loop: true,
    //   slidesPerView: 3,
    //   coverflowEffect: {
    //     rotate: 0,
    //     stretch: 0,
    //     depth: 150,
    //     modifer: 2.5,
    //     slideShadows: true,
    //     slide,
    //   },
    // });

    new Swiper(".swiper", {
      modules: [
        s,
        t,
        r,
        function ({ swiper: e, on: s, extendParams: t }) {
          t({
            carouselEffect: {
              opacityStep: 0.33,
              scaleStep: 0.2,
              sideSlides: 2,
            },
          }),
            s("beforeInit", () => {
              if ("carousel" !== e.params.effect) return;
              e.classNames.push(`${e.params.containerModifierClass}carousel`);
              const s = {
                watchSlidesProgress: !0,
                centeredSlides: !0,
              };
              Object.assign(e.params, s), Object.assign(e.originalParams, s);
            }),
            s("progress", () => {
              if ("carousel" !== e.params.effect) return;
              const { scaleStep: s, opacityStep: t } = e.params.carouselEffect,
                r = Math.max(
                  Math.min(e.params.carouselEffect.sideSlides, 3),
                  1
                ),
                a = {
                  1: 2,
                  2: 1,
                  3: 0.2,
                }[r],
                o = {
                  1: 50,
                  2: 50,
                  3: 67,
                }[r],
                i = e.slides.length;
              for (let l = 0; l < e.slides.length; l += 1) {
                const n = e.slides[l],
                  c = e.slides[l].progress,
                  p = Math.abs(c);
                let d = 1;
                p > 1 && (d = 0.3 * (p - 1) * a + 1);
                const u = n.querySelectorAll(
                    ".swiper-carousel-animate-opacity"
                  ),
                  f = c * d * o * (e.rtlTranslate ? -1 : 1) + "%",
                  m = 1 - p * s,
                  y = i - Math.abs(Math.round(c));
                (n.style.transform = `translateX(${f}) scale(${m})`),
                  (n.style.zIndex = y),
                  (n.style.opacity = p > r + 1 ? 0 : 1),
                  u.forEach((e) => {
                    e.style.opacity = 1 - p * t;
                  });
              }
            }),
            s("resize", () => {
              e.virtual &&
                e.params.virtual &&
                e.params.virtual.enabled &&
                requestAnimationFrame(() => {
                  e.destroyed || (e.updateSlides(), e.updateProgress());
                });
            }),
            s("setTransition", (s, t) => {
              if ("carousel" === e.params.effect)
                for (let r = 0; r < e.slides.length; r += 1) {
                  const s = e.slides[r],
                    a = s.querySelectorAll(".swiper-carousel-animate-opacity");
                  (s.style.transitionDuration = `${t}ms`),
                    a.forEach((e) => {
                      e.style.transitionDuration = `${t}ms`;
                    });
                }
            });
        },
      ],
      effect: "carousel",
      carouselEffect: {
        opacityStep: 0.33,
        scaleStep: 0.2,
        sideSlides: 2,
      },
      grabCursor: !0,
      loop: !0,
      loopAdditionalSlides: 1,
      slidesPerView: "auto",
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
      },
      autoplay: {
        delay: 3e3,
      },
    });
  }
}
